import { BaseQuery } from "./_BaseQuery";

export class VisitingFrequencyQuery extends BaseQuery {
	public id?:string;
}
